import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import _ from "lodash";
import sanitizeHtml from "sanitize-html";
import { cn } from "@/lib/utils";
type CheckboxInputProps = {
  elementId: string;
  label: string;
  disabled?: boolean;
};
function CheckboxInput({
  elementId,
  label,
  disabled = false
}: CheckboxInputProps) {
  const form = useFormContext();
  useEffect(() => {
    if (_.get(form.getValues(), elementId) === undefined) {
      form.setValue(elementId, false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementId]);
  return <FormField control={form.control} name={elementId} render={({
    field
  }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md py-2">
          <FormControl>
            <Checkbox className={!disabled ? "cursor-pointer" : ""} disabled={disabled} checked={field.value} onCheckedChange={field.onChange} />
          </FormControl>
          <FormLabel>
            <div className={cn("space-y-1 leading-none", !disabled ? "cursor-pointer" : "")} dangerouslySetInnerHTML={{
        __html: sanitizeHtml(label)
      }}></div>
          </FormLabel>
        </FormItem>} data-sentry-element="FormField" data-sentry-component="CheckboxInput" data-sentry-source-file="CheckboxInput.tsx" />;
}
export default CheckboxInput;